"use strict";
var LlCartDirective = (function () {
    function LlCartDirective($rootScope, toaster, $http, $modal) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.toaster = toaster;
        this.$http = $http;
        this.$modal = $modal;
        this.restrict = "AE";
        this.scope = {
            // przedmioty kalkulacji
            requestItems: "=",
            // obiekt ze zmianami, dla powiadomień ( {wasItemAdded: ..., wasItemDeleted: ..., wasItemChanged: ...} )
            changes: "=",
            // czy ma się pojawić przycisk "Dodaj dostawcę"
            canAddSupplier: "@",
            // requestGuid
            requestGuid: '@'
        };
        this.templateUrl = "/WWW/partials/modules/cart.form.html";
        this.link = function (scope, elem, attr) {
            // wartość domyślna canAddSupplier
            if (angular.isUndefined(scope.canAddSupplier)) {
                scope.canAddSupplier = false;
            }
            scope.http = _this.$http;
            var rs = _this.$rootScope;
            // pobranie danych slownikowych
            scope.http.get('/OfferBusinessData/GetCategoryLevels').then(function (d) {
                scope.categoryDic = d.data;
            }, function (e) {
                _this.toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
            });
            // pobranie produktów partnera, na którego założona jest sprawa + ewentualnych dodatych produktów domyślnych
            if (typeof scope.requestGuid === "undefined")
                scope.requestGuid = "";
            scope.http.get('/OfferBusinessData/GetCategoryLevelsForRequest' + '?calculationId=' + scope.requestGuid).then(function (d) {
                // zmienna przechowująca produkty partnera, na którego jest założona sprawa - pobierane przy edycji koszyka na sprawie
                scope.categoryForRequestDic = d.data;
            }, function (e) {
                _this.toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
            });
            // rekalkulacja
            // scope.calculate = function (item) {
            //     var pNet = parseFloat(item.NetPrice);
            //     var pGross = parseFloat(item.GrossPrice);
            //     var q = parseFloat(item.Quantity);
            //     var taxCode = item.TaxCode;
            //     var tax = parseFloat(taxCode == 'zw' ? "0" : parseFloat(taxCode).toString());
            //     item.NetValue = parseFloat((pNet * q).toString());
            //     item.GrossPrice = parseFloat((pNet * (1 + tax / 100)).toString());
            //     item.GrossValue = parseFloat((item.NetValue * (1 + tax / 100)).toString());
            //     item.TaxValue = item.GrossValue - item.NetValue;
            //     scope.changes.wasRequestsListChanged = true;
            // };
            scope.calculate = function (item) {
                var pNet = parseFloat(item.NetPrice);
                var q = parseFloat(item.Quantity);
                var taxCode = item.TaxCode;
                var tax = (taxCode == "zw" ? 0 : parseFloat(taxCode));
                var discount = parseFloat(item.Discount || "0");
                item.NetValue = (pNet * q) * (1 - discount / 100);
                item.GrossPrice = (pNet * (1 + tax / 100));
                item.GrossValue = ((item.NetValue) * (1 + tax / 100));
                item.TaxValue = (item.GrossValue - item.NetValue);
                //console.debug("calculate", item);
                scope.changes.wasRequestsListChanged = true;
            };
            // usunięcie pozycji
            scope.deleteBasketItem = function (array, idx) {
                array.splice(idx, 1);
                scope.changes.wasRequestsListChanged = true;
            };
            // dodanie pozycji
            scope.addRequestItem = function () {
                var item = {
                    TaxCode: "23",
                    Tax: "23",
                    Quantity: 1
                };
                scope.requestItems.push(item);
                scope.changes.wasRequestsListChanged = true;
            };
            scope.modal = _this.$modal;
            scope.addSupplier = function (item) {
                var modalInstance = scope.modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/addSupplierModal.html',
                    controller: ['$scope', '$modalInstance', 'requestItem', function ($scope, $modalInstance, requestItem) {
                            $scope.requestItem = requestItem;
                            $scope.ok = function () {
                                $modalInstance.close($scope.requestItem);
                            };
                            $scope.removeData = function () {
                                $scope.requestItem.SupplierNip = undefined;
                                $modalInstance.close($scope.requestItem);
                            };
                            $scope.cancel = function () {
                                $modalInstance.dismiss('cancel');
                            };
                        }],
                    scope: scope,
                    resolve: {
                        requestItem: function () {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    var _this = this;
                    scope.http.put('/api/ProductUpdate/' + scope.requestGuid, scope.requestItems).then(function (d) {
                        //scope.categoryDic = d.data;
                        rs.$broadcast('showRequestBroadcast', { id: scope.requestGuid });
                    }, function (e) {
                        _this.toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
                    });
                }, function () { });
            };
        };
    }
    LlCartDirective.Factory = function () {
        var dir = function ($rootScope, toaster, $http, $modal) { return new LlCartDirective($rootScope, toaster, $http, $modal); };
        dir.$inject = ["$rootScope", "toaster", "$http", "$modal"];
        return dir;
    };
    return LlCartDirective;
}());
var DataChooserDirective = (function () {
    function DataChooserDirective($modal) {
        var _this = this;
        this.$modal = $modal;
        this.restrict = "A";
        this.require = "ngModel";
        // otworzenie modalu
        this.openResultModel = function (forItem) {
            var _self = _this;
            var modalInstance = _this.$modal.open({
                animation: true,
                templateUrl: '/WWW/partials/modules/data.chooser.html',
                controller: 'DataChooserModalCtrl',
                resolve: {
                    config: function () { return _self.config; }
                }
            });
            // wybranie elementu
            modalInstance.result.then(function (item) {
                if (typeof _self.config.onSelect !== "undefined") {
                    _self.config.onSelect(forItem, item);
                }
            }, function () {
            });
        };
        this.config = {};
        this.scope = {
            onSelect: "=emqDataChooserOnSelect",
            forItem: "=emqDataChooserForItem"
        };
        this.link = function (scope, elem, attr, model) {
            var _self = _this;
            // konfiguracja
            _self.config = JSON.parse(attr['emqDataChooser'] || "{}");
            _self.config.onSelect = scope.onSelect;
            // podmapowanie zdarzenia
            elem.bind('keydown', function (e) {
                // F1 - otwarcie dailogu
                if (e.keyCode === 112 || e.keyCode === 13) {
                    e.preventDefault();
                    // pobieranie danych z uslugi
                    _self.openResultModel(scope.forItem);
                }
            });
        };
    }
    DataChooserDirective.Factory = function () {
        var dir = function ($modal) { return new DataChooserDirective($modal); };
        dir.$inject = ['$modal'];
        return dir;
    };
    return DataChooserDirective;
}());
var DataChooserModalCtrl = (function () {
    function DataChooserModalCtrl($scope, $modalInstance, $http, config) {
        var _this = this;
        this.$scope = $scope;
        this.$modalInstance = $modalInstance;
        this.$http = $http;
        this.config = config;
        // pobranie dancyh
        this.getRemoteData = function (filter) {
            return _this.$http.post(_this.config.url, { filter: (filter) });
        };
        var _self = this;
        // informacje do popbrania                
        $scope.label = _self.config.label || 'label';
        $scope.desc = _self.config.desc || 'desc';
        $scope.items = [];
        // potwierdzenie wyboru
        $scope.onSelectItem = function (item) {
            $modalInstance.close(item);
        };
        // pobranie danych
        _self.getRemoteData("").then(function (d) {
            $scope.items = d.data;
        }, function (e) {
        });
    }
    DataChooserModalCtrl.$inject = ['$scope', '$modalInstance', '$http', 'config'];
    return DataChooserModalCtrl;
}());
//module llPartnerPanel {
// content
var PartnerPanelContentDirective = (function () {
    function PartnerPanelContentDirective(PartnerPanelService) {
        var _this = this;
        this.PartnerPanelService = PartnerPanelService;
        this.restrict = "A";
        this.templateUrl = "/WWW/partials/modules/partner.panel.content.html";
        this.link = function (scope, elem, attr) {
            var _self = _this;
            // ustawienie zakladki
            scope.setCurrentTab = function (tab) {
                scope.currentTab = tab;
            };
            // przejscie na oferte
            scope.openResponse = function (id) {
                var _self = _this;
                var _url = "/process/choose.offer/" + id;
                top.location.href = _url;
            };
            // zmienne
            if (!scope.process || !scope.process.Guid) {
                //scope.currentTab = 'new_request';
                scope.Request = _self.PartnerPanelService.PrepareRequest();
            }
        };
    }
    PartnerPanelContentDirective.Factory = function () {
        var dir = function (PartnerPanelService) { return new PartnerPanelContentDirective(PartnerPanelService); };
        dir.$inject = ['PartnerPanelService'];
        return dir;
    };
    return PartnerPanelContentDirective;
}());
//} 
var systemMediaMarkt;
(function (systemMediaMarkt) {
    // glowna dyrektywa
    var PartnerMediaMarktPanelCtrl = (function () {
        function PartnerMediaMarktPanelCtrl($scope) {
        }
        PartnerMediaMarktPanelCtrl.$inject = ['$scope'];
        return PartnerMediaMarktPanelCtrl;
    }());
    var PartnerMediaMarktPanelDir = (function () {
        function PartnerMediaMarktPanelDir() {
            this.restrict = "AE";
            this.template = "<div class=\"partner-panel page wrap\">\n        \n        <div class=\"info t-center\">\n\n        <ll-partner-media-markt-agreement ng-if=\"process.Step == 'agreement'\"></ll-partner-media-markt-agreement>\n        <ll-partner-media-markt-initial-payment ng-if=\"process.Step == 'initial-payment'\"></ll-partner-media-markt-initial-payment>\n        <ll-partner-media-markt-send-delivery ng-if=\"process.Step == 'send-delivery'\"></ll-partner-media-markt-send-delivery>\n        <ll-partner-media-markt-default ng-if=\"['agreement' , 'initial-payment' , 'send-delivery'].indexOf(process.Step) === -1\"></ll-partner-media-markt-default>\n\n\n        </div>\n\n\n        </div>";
            this.controller = PartnerMediaMarktPanelCtrl;
            this.scope = {
                user: "=",
                requestId: "@",
                process: "="
            };
        }
        PartnerMediaMarktPanelDir.Factory = function () {
            var d = function () { return new PartnerMediaMarktPanelDir(); };
            d['$inject'] = [];
            return d;
        };
        return PartnerMediaMarktPanelDir;
    }());
    systemMediaMarkt.PartnerMediaMarktPanelDir = PartnerMediaMarktPanelDir;
    // dyrektywa oddrukowania umowy i potwierdzenia umowy
    var PartnerMediaMarktAgreementCtrl = (function () {
        function PartnerMediaMarktAgreementCtrl($scope, $http, toaster) {
            var _this = this;
            this.$scope = $scope;
            this.$http = $http;
            this.toaster = toaster;
            this.url = "/api/PartnerMediaMarktAgreement";
            this.getAgreementDocumentList = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.get(_url);
            };
            this.acceptAgreementDocumentList = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.put(_url);
            };
            var _self = this;
            $scope.refresh = function () {
                $scope.isLoaded = false;
                _self.getAgreementDocumentList().then(function (d) {
                    $scope.data = d.data.Result;
                    $scope.isLoaded = true;
                });
            };
            // pokazanie dokumentu
            $scope.showDocument = function (fileId) {
                window.open("/document/show?fileId=" + fileId);
            };
            // potwierdzenie wszystkich
            $scope.acceptAllDocuments = function () {
                if (confirm("Czy na pewno chcesz potwierdzić podpisanie umowy?")) {
                    _self.acceptAgreementDocumentList().then(function (d) {
                        toaster.pop("success", "Akceptacja", "Umowa zaakceptowana poprawnie");
                        // przekierowanie do kolejnego kroku
                        top.location.reload();
                    }, function (e) {
                        toaster.pop("error", "Błąd", "Wystąpił błąd podczas akceptowania umowy");
                        console.error(e);
                    });
                }
            };
            $scope.isLoaded = false;
            $scope.refresh();
        }
        PartnerMediaMarktAgreementCtrl.$inject = ['$scope', '$http', 'toaster'];
        return PartnerMediaMarktAgreementCtrl;
    }());
    var PartnerMediaMarktAgreementDir = (function () {
        function PartnerMediaMarktAgreementDir() {
            this.controller = PartnerMediaMarktAgreementCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/partner.panel.media.markt/partner.media.markt.agreement.html";
        }
        PartnerMediaMarktAgreementDir.Factory = function () {
            var d = function () { return new PartnerMediaMarktAgreementDir(); };
            d['$inject'] = [];
            return d;
        };
        return PartnerMediaMarktAgreementDir;
    }());
    systemMediaMarkt.PartnerMediaMarktAgreementDir = PartnerMediaMarktAgreementDir;
    // dyrektywa wygenerowania platnosc
    var PartnerMediaMarktInitialPaymentCtrl = (function () {
        function PartnerMediaMarktInitialPaymentCtrl($scope, $http, toaster) {
            var _this = this;
            this.$scope = $scope;
            this.$http = $http;
            this.toaster = toaster;
            this.url = "/api/PartnerMediaMarktInitialPayment";
            this.getInitialPaymentData = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.get(_url);
            };
            this.resendInitialPaymentData = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.put(_url);
            };
            var _self = this;
            $scope.refresh = function () {
                $scope.isLoaded = false;
                _self.getInitialPaymentData().then(function (d) {
                    $scope.data = d.data.Result;
                    $scope.isLoaded = true;
                });
            };
            // potwierdzenie wszystkich
            $scope.sendInitialPaymentNotificatication = function () {
                if (confirm("Czy na pewno chcesz wysłać jeszcze raz informacje o płatności?")) {
                    _self.resendInitialPaymentData().then(function (d) {
                        toaster.pop("success", "Ponownie płatności", "Informacja została przesłana poprawnie");
                        // przekierowanie do kolejnego kroku
                        //top.location.reload();
                    }, function (e) {
                        toaster.pop("error", "Błąd", "Wystąpił błąd podczas przesyłania informacji");
                        console.error(e);
                    });
                }
            };
            //sprawdzenie statusu = przeladowanie strony
            $scope.checkStatus = function () {
                top.location.reload();
            };
            $scope.isLoaded = false;
            $scope.refresh();
        }
        PartnerMediaMarktInitialPaymentCtrl.$inject = ['$scope', '$http', 'toaster'];
        return PartnerMediaMarktInitialPaymentCtrl;
    }());
    var PartnerMediaMarktInitialPaymentDir = (function () {
        function PartnerMediaMarktInitialPaymentDir() {
            this.controller = PartnerMediaMarktInitialPaymentCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/partner.panel.media.markt/partner.media.markt.initial.payment.html";
        }
        PartnerMediaMarktInitialPaymentDir.Factory = function () {
            var d = function () { return new PartnerMediaMarktInitialPaymentDir(); };
            d['$inject'] = [];
            return d;
        };
        return PartnerMediaMarktInitialPaymentDir;
    }());
    systemMediaMarkt.PartnerMediaMarktInitialPaymentDir = PartnerMediaMarktInitialPaymentDir;
    // dyrektywa potwierdzenia wydania towaru
    var PartnerMediaMarktSendDeliveryCtrl = (function () {
        function PartnerMediaMarktSendDeliveryCtrl($scope, $http, toaster) {
            var _this = this;
            this.$scope = $scope;
            this.$http = $http;
            this.toaster = toaster;
            this.url = "/api/PartnerMediaMarktSendDelivery";
            this.getSendDeliveryData = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.get(_url);
            };
            this.acceptSendDeliveryData = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.put(_url);
            };
            var _self = this;
            $scope.refresh = function () {
                $scope.isLoaded = false;
                _self.getSendDeliveryData().then(function (d) {
                    $scope.data = d.data.Result;
                    $scope.isLoaded = true;
                });
            };
            // potwierdzenie wszystkich
            $scope.acceptSendDelivery = function () {
                //if (confirm("Czy na pewno chcesz potwierdzić wydanie towaru?")) {
                _self.acceptSendDeliveryData().then(function (d) {
                    toaster.pop("success", "Potwierdzenie wydania", "Wydanie towaru potwierdzono poprawnie");
                    // przekierowanie do kolejnego kroku
                    top.location.reload();
                }, function (e) {
                    toaster.pop("error", "Błąd", "Wystąpił błąd podczas potwierdzania wydania towaru");
                    console.error(e);
                });
                //}
            };
            $scope.isLoaded = false;
            $scope.refresh();
        }
        PartnerMediaMarktSendDeliveryCtrl.$inject = ['$scope', '$http', 'toaster'];
        return PartnerMediaMarktSendDeliveryCtrl;
    }());
    var PartnerMediaMarktSendDeliveryDir = (function () {
        function PartnerMediaMarktSendDeliveryDir() {
            this.controller = PartnerMediaMarktSendDeliveryCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/partner.panel.media.markt/partner.media.markt.send.delivery.html";
        }
        PartnerMediaMarktSendDeliveryDir.Factory = function () {
            var d = function () { return new PartnerMediaMarktSendDeliveryDir(); };
            d['$inject'] = [];
            return d;
        };
        return PartnerMediaMarktSendDeliveryDir;
    }());
    systemMediaMarkt.PartnerMediaMarktSendDeliveryDir = PartnerMediaMarktSendDeliveryDir;
    // dyrektywa domyslna
    var PartnerMediaMarktDefaultCtrl = (function () {
        function PartnerMediaMarktDefaultCtrl($scope, $http, toaster) {
            var _this = this;
            this.$scope = $scope;
            this.$http = $http;
            this.toaster = toaster;
            this.url = "/api/PartnerMediaMarktDefault";
            this.getOrderData = function () {
                var _url = _this.url + "/" + _this.$scope.requestId;
                return _this.$http.get(_url);
            };
            var _self = this;
            $scope.refresh = function () {
                $scope.isLoaded = false;
                _self.getOrderData().then(function (d) {
                    $scope.data = d.data.Result;
                    $scope.isLoaded = true;
                });
            };
            $scope.isLoaded = false;
            $scope.refresh();
        }
        PartnerMediaMarktDefaultCtrl.$inject = ['$scope', '$http', 'toaster'];
        return PartnerMediaMarktDefaultCtrl;
    }());
    var PartnerMediaMarktDefaultDir = (function () {
        function PartnerMediaMarktDefaultDir() {
            this.controller = PartnerMediaMarktDefaultCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/partner.panel.media.markt/partner.media.markt.default.html";
        }
        PartnerMediaMarktDefaultDir.Factory = function () {
            var d = function () { return new PartnerMediaMarktDefaultDir(); };
            d['$inject'] = [];
            return d;
        };
        return PartnerMediaMarktDefaultDir;
    }());
    systemMediaMarkt.PartnerMediaMarktDefaultDir = PartnerMediaMarktDefaultDir;
})(systemMediaMarkt || (systemMediaMarkt = {}));
angular.module("ll.mediamark", ['ngSanitize'])
    .directive("llPartnerMediaMarktPanel", systemMediaMarkt.PartnerMediaMarktPanelDir.Factory())
    .directive("llPartnerMediaMarktAgreement", systemMediaMarkt.PartnerMediaMarktAgreementDir.Factory())
    .directive("llPartnerMediaMarktInitialPayment", systemMediaMarkt.PartnerMediaMarktInitialPaymentDir.Factory())
    .directive("llPartnerMediaMarktSendDelivery", systemMediaMarkt.PartnerMediaMarktSendDeliveryDir.Factory())
    .directive("llPartnerMediaMarktDefault", systemMediaMarkt.PartnerMediaMarktDefaultDir.Factory());
//module llPartnerPanel {
// menu
var PartnerPanelMenuDirective = (function () {
    function PartnerPanelMenuDirective(PartnerPanelService, $rootScope) {
        var _this = this;
        this.PartnerPanelService = PartnerPanelService;
        this.$rootScope = $rootScope;
        this.restrict = "A";
        this.templateUrl = "/WWW/partials/modules/partner.panel.menu.html";
        this.link = function (scope, elem, attr) {
            // dodanie nowego elementu
            scope.addNewRequest = function () {
                scope.currentTab = 'new_request';
                scope.Request = _this.PartnerPanelService.PrepareRequest();
                _this.$rootScope.$broadcast("leaselink::new_request");
            };
            // anulowanie dodawania
            scope.cancelNewRequest = function () {
                scope.currentTab = '';
            };
            // pobranie danych
            scope.refresh = function () {
                /*
                this
                    .PartnerPanelService
                    .GetOfferResponseList()
                    .then(
                    (d) => {
                        scope.list = d.data;
                    });
                    */
            };
            // zmienne
            scope.list = [];
            // domyslan akcja 
            scope.refresh();
        };
    }
    PartnerPanelMenuDirective.Factory = function () {
        var dir = function (PartnerPanelService, $rootScope) { return new PartnerPanelMenuDirective(PartnerPanelService, $rootScope); };
        dir.$inject = ['PartnerPanelService', '$rootScope'];
        return dir;
    };
    return PartnerPanelMenuDirective;
}());
//} 
'use strict';
var PartnerPanelRequestFormDirective = (function () {
    function PartnerPanelRequestFormDirective(PartnerPanelService, toaster, $rootScope, $location, $modal) {
        var _this = this;
        this.PartnerPanelService = PartnerPanelService;
        this.toaster = toaster;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$modal = $modal;
        this.restrict = "A";
        this.templateUrl = "/WWW/partials/modules/partner.panel.request.form.html";
        this.link = function (scope, elem, attr) {
            var _self = _this;
            // wyslanie i zapisanie
            scope.sendRequest = function () {
                scope.processRequest(false);
            };
            // symulacja
            scope.simulateRequest = function () {
                scope.processRequest(true);
            };
            // zapisanie oferty
            scope.processRequest = function (isSimulation) {
                //pelne przeliczenie
                scope.Request.FullRecalculation = true;
                scope.Request.PartnerUserGuid = scope.user.Guid;
                scope.Request.PartnerUserName = scope.user.LastName + ", " + scope.user.FirstName;
                scope.Request.PartnerName = scope.user.Partner;
                scope.Request.SaveInProcess = true;
                var SendProposal = (isSimulation !== true);
                scope.Request.Simulation = isSimulation;
                scope.Request.UserExternalId = scope.user.ExternalId;
                //scope.Request.OfferCreationSource = "ProcessOfferByPartner";
                scope.Request.ClientGoBackUrl = '/ProcessOfferByPartner'; //?externalId=' + scope.user.ExternalId;
                // wyslanie            
                _self
                    .PartnerPanelService
                    .SendOfferRequest(scope.Request, SendProposal)
                    .then(function (d) {
                    if (d.data.StatusCode == 200) {
                        //_self.toaster.pop('success', "Przygotowanie kalkulacji", "Przygotowanie kalkulacji przebiegło poprawnie.");
                        var AggragatedCalulationId = d.data.Result.AggragatedCalulationId;
                        scope.Request.AggragatedCalulationId = AggragatedCalulationId;
                        if (scope.user && ['DHMLEA', 'CCMLEA'].indexOf(scope.user.ExternalId) !== -1) {
                            scope.onCloseClick = function () {
                                window.location.href = 'https://leaselink.pl';
                            };
                            var modalInstance = _self.$modal.open({
                                animation: true,
                                template: "\n                                <div style=\"padding: 4rem; text-align:center;\">\n                                    <div class=\"modal-body\">\n                                        <div style=\"font-size: 1.1rem;\">\n                                        <p>Aleeeee extra \u017Ce z nami wsp\u00F3\u0142pracujesz.</p>\n                                        <p>Bardzo si\u0119 staramy aby\u015B by\u0142 z nas zadowolony.</p>\n                                        <br/>\n                                        <br/>\n                                        <p>Skontaktujemy si\u0119 z Tob\u0105 z informacj\u0105 zwrotn\u0105 dotycz\u0105c\u0105 tego Klienta i tej transakcji.</p>\n                                        </div>\n                                        <br/>\n                                        <br/>\n                                        <br/>\n                                        <button class=\"btn btn-default\" ng-click=\"onCloseClick()\">Zamknij</button>\n                                    </div>\n                                </div>\n                                ",
                                scope: scope,
                                size: 'lg'
                            });
                        }
                        else {
                            // od razu otwarcie
                            scope.openResponse(AggragatedCalulationId);
                        }
                    }
                    else {
                        var error = (d && d.data && d.data.Error && d.data.Error.Message) ? (" " + d.data.Error.Message + ".") : d.data.Error;
                        _self.toaster.pop('error', "Przygotowanie kalkulacji", error);
                    }
                }, function (e) {
                    var error = (e && e.data && e.data.Error && e.data.Error.Message) ? (" " + e.data.Error.Message + ".") : "";
                    _self.toaster.pop('error', "Przygotowanie kalkulacji", "Przygotowanie kalkulacji nie przebiegło poprawnie." + error);
                });
            };
            // pobranie kategorii
            scope.getCategories = function () {
                _self.PartnerPanelService.GetCategories().then(function (d) { scope.categoryDic = _.map(d.data, function (i) { return { ProductCategory: i.ProductCategory }; }); }, function (e) {
                    _self.toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
                });
            };
            // dodanie zdarzenia nasluchu
            _self.$rootScope.$on("leaselink::new_request", function (e) {
                // przygotowanie nowego zapytania
                scope.Request = _self.PartnerPanelService.PrepareRequest();
            });
            // zmienne
            scope.categoryDic = [];
            // domyslnie
            scope.getCategories();
        };
    }
    PartnerPanelRequestFormDirective.Factory = function () {
        var dir = function (PartnerPanelService, toaster, $rootScope, $location, $modal) { return new PartnerPanelRequestFormDirective(PartnerPanelService, toaster, $rootScope, $location, $modal); };
        dir.$inject = ['PartnerPanelService', 'toaster', '$rootScope', '$location', '$modal'];
        return dir;
    };
    return PartnerPanelRequestFormDirective;
}());
//module llPartnerPanel {
var PartnerPanelService = (function () {
    function PartnerPanelService($http) {
        var _this = this;
        this.$http = $http;
        // pobranie kategorii
        this.GetCategories = function () {
            // pobranie danych slownikowych
            var _url = '/OfferBusinessData/GetCategoryLevels';
            return _this.$http.get(_url);
        };
        // przygotowanie oferty
        this.PrepareRequest = function () {
            var req = {
                SaveDataEmail: "",
                Requestors: [{}],
                RequestItems: [
                    {
                        TaxCode: "23",
                        Tax: 23,
                        Quantity: 1,
                        NetPrice: 0,
                        GrossPrice: 0,
                        NetValue: 0,
                        TaxValue: 0,
                        GrossValue: 0
                    }
                ]
            };
            return req;
        };
        // wyslanie ofert
        this.SendOfferToClient = function (id) {
            return _this.$http.post("/system/process/send/" + id);
        };
        // 
        // pobranie listy ofert
        this.GetOfferResponseList = function () {
            var _url = "/ProcessOfferByPartner/GetOffersInProcessList";
            return _this.$http.post(_url, {});
        };
        // wyslanie oferty do przeliczenia
        this.SendOfferRequest = function (req, SendProposal) {
            var _url = "/api/OfferForClient?SendProposal=" + SendProposal;
            //console.debug(_url);
            return _this.$http.post(_url, req);
        };
        this.GetOfferResponse = function (id) {
            var _url = '/OfferRequest/get/' + id;
            return _this.$http.get(_url);
        };
    }
    PartnerPanelService.$inject = ['$http'];
    return PartnerPanelService;
}());
//} 
//module llPartnerPanel {
// dyrektywa tworzenia panelu partnera
var PartnerPanelDirective = (function () {
    function PartnerPanelDirective(PartnerPanelService) {
        this.PartnerPanelService = PartnerPanelService;
        this.restrict = "A";
        this.templateUrl = "/WWW/partials/modules/partner.panel.html";
        this.link = function (scope, elem, attr) {
            var _data = JSON.parse(attr['llPartnerPanel'] || "{}");
            scope.user = _data.user;
            scope.process = _data.process;
            scope.Request = _data.request;
            scope.partner = _data.partner;
        };
    }
    PartnerPanelDirective.Factory = function () {
        var dir = function (PartnerPanelService) { return new PartnerPanelDirective(PartnerPanelService); };
        dir.$inject = ['PartnerPanelService'];
        return dir;
    };
    return PartnerPanelDirective;
}());
//} 
// dyrektywa do generowania umow
var GenerateAgreementButtonDirective = (function () {
    function GenerateAgreementButtonDirective($http, $parse, $toaster) {
        var _this = this;
        this.$http = $http;
        this.$parse = $parse;
        this.$toaster = $toaster;
        this.restrict = "AE";
        // generowanie umowy
        this.generateAgreement = function (model) {
            var url = "/document/generateAgreement/" + model.AggragatedCalculation_Guid;
            return _this.$http.post(url, { agreementNumber: model.Guid });
        };
        this.link = function (scope, element, attrs) {
            var _self = _this;
            // pobranie ngModel
            var ngModel = _this.$parse(attrs["ngModel"]);
            // generowanie umowy
            scope.GenerateAgreement = function () {
                var _model = ngModel(scope);
                _self
                    .generateAgreement(_model)
                    .then(function (d) {
                    _self.$toaster.pop('success', 'Pomyślnie dodano nową umowę');
                }, function (e) {
                    _self.$toaster.pop('error', 'Błąd podczas dodawania nowej umowy');
                });
            };
        };
        this.template = "\n    <button class=\"btn btn-sm btn-primary\" ng-click=\"GenerateAgreement()\">Wygeneruj</button>\n    ";
    }
    GenerateAgreementButtonDirective.Factory = function () {
        var dir = function ($http, $parse, $toaster) { return new GenerateAgreementButtonDirective($http, $parse, $toaster); };
        dir.$inject = ['$http', '$parse', 'toaster'];
        return dir;
    };
    return GenerateAgreementButtonDirective;
}());
'use strict';
// zapytanie
var RequestFormDirective = (function () {
    function RequestFormDirective($service) {
        var _this = this;
        this.$service = $service;
        this.restrict = "A";
        this.templateUrl = "/WWW/partials/modules/request.form.new.html";
        this.link = function (scope, elem, attr) {
            // dodanie pozycji
            scope.addRequestItem = function () {
                var item = {
                    TaxCode: "23",
                    Tax: "23",
                    Quantity: 1,
                    Categories: []
                };
                scope.Request.RequestItems.push(item);
            };
            // usuniecie pozycji
            scope.deleteRequestItem = function (idx) {
                scope.Request.RequestItems.splice(idx, 1);
            };
            // rekalkulacja  netto
            scope.calculate = function (item) {
                var pNet = parseFloat(item.NetPrice);
                var q = parseFloat(item.Quantity);
                var taxCode = item.TaxCode;
                var tax = (taxCode == "zw" ? 0 : parseFloat(taxCode));
                var discount = parseFloat(item.Discount || "0");
                item.NetValue = (pNet * q) * (1 - discount / 100);
                item.GrossPrice = (pNet * (1 + tax / 100));
                item.GrossValue = ((item.NetValue) * (1 + tax / 100));
                item.TaxValue = (item.GrossValue - item.NetValue);
            };
            scope.formatDecimals = function (val) {
                var _num = val.toFixed(2);
                var __num = parseFloat(_num);
                return __num;
            };
            // rekalkulacja brutto
            scope.calculateFromGross = function (item) {
                var pGross = parseFloat(item.GrossPrice);
                var q = parseFloat(item.Quantity);
                var taxCode = item.TaxCode;
                var tax = (taxCode == 'zw' ? 0 : parseFloat(taxCode));
                var discount = parseFloat(item.Discount || "0");
                item.GrossValue = (pGross * q) * (1 - discount / 100);
                item.NetPrice = (pGross / (1 + tax / 100));
                item.NetValue = (item.GrossValue / (1 + tax / 100));
                item.TaxValue = (item.GrossValue - item.NetValue);
            };
            // aktualizacja sum
            scope.updateTotals = function () {
                scope.NetValueTotal = 0;
                scope.TaxValueTotal = 0;
                scope.GrossValueTotal = 0;
                scope.Request.RequestItems.forEach(function (e) {
                    scope.NetValueTotal += (e.NetValue || 0);
                    scope.TaxValueTotal += (e.TaxValue || 0);
                    scope.GrossValueTotal += (e.GrossValue || 0);
                });
            };
            // pobranie danych o produkcie jak wroca na koszyk
            scope.updateCurrentItemData = function (currentItem) {
                _this.$service.getProductData(currentItem.Name).then(function (d) {
                    var selectedValue = d.data;
                    if (selectedValue) {
                        if (selectedValue.ProductDiscountAllowed)
                            currentItem.ProductDiscountAllowed = selectedValue.ProductDiscountAllowed;
                        if (selectedValue.ProductDiscounts)
                            currentItem.ProductDiscounts = selectedValue.ProductDiscounts;
                        if (selectedValue.ProductPriceChangeBlock)
                            currentItem.ProductPriceChangeBlock = selectedValue.ProductPriceChangeBlock;
                        if (selectedValue.ProductTaxChangeBlock)
                            currentItem.ProductTaxChangeBlock = selectedValue.ProductTaxChangeBlock;
                    }
                });
            };
            // wybranie produktu
            scope.onProductSelected = function (currentItem, selectedValue) {
                currentItem.Name = "";
                currentItem.CategoryLevel1 = "";
                currentItem.TaxCode = "";
                currentItem.NetPrice = "";
                currentItem.GrossPrice = "";
                currentItem.ProductCategories = [];
                currentItem.ProductPaneltyFee = null;
                currentItem.ProductAddInfo = "";
                currentItem.ProductTypeName = "";
                if (selectedValue.ProductName)
                    currentItem.Name = selectedValue.ProductName;
                //if (selectedValue.ProductCategory) currentItem.CategoryLevel1 = selectedValue.ProductCategory;
                if (selectedValue.ProductTaxCode)
                    currentItem.TaxCode = selectedValue.ProductTaxCode;
                if (selectedValue.ProductNetPrice)
                    currentItem.NetPrice = selectedValue.ProductNetPrice;
                if (selectedValue.ProductGrossPrice)
                    currentItem.GrossPrice = selectedValue.ProductGrossPrice;
                //if (selectedValue.ProductCategories) currentItem.ProductCategories = _.map(selectedValue.ProductCategories, (i: string) => { return { ProductCategory: i }; });
                if (selectedValue.ProductDiscountAllowed)
                    currentItem.ProductDiscountAllowed = selectedValue.ProductDiscountAllowed;
                if (selectedValue.ProductDiscounts)
                    currentItem.ProductDiscounts = selectedValue.ProductDiscounts;
                if (selectedValue.ProductPriceChangeBlock)
                    currentItem.ProductPriceChangeBlock = selectedValue.ProductPriceChangeBlock;
                if (selectedValue.ProductTaxChangeBlock)
                    currentItem.ProductTaxChangeBlock = selectedValue.ProductTaxChangeBlock;
                if (selectedValue.ProductPaneltyFee)
                    currentItem.ProductPaneltyFee = selectedValue.ProductPaneltyFee;
                if (selectedValue.ProductAddInfo)
                    currentItem.ProductAddInfo = selectedValue.ProductAddInfo;
                if (selectedValue.ProductTypeName)
                    currentItem.ProductTypeName = selectedValue.ProductTypeName;
                if (selectedValue.IgnoreValidation)
                    currentItem.IgnoreValidation = selectedValue.IgnoreValidation;
                // przeliczenie
                scope.calculate(currentItem);
                scope.getCategoriesForProduct(currentItem);
            };
            // nalenienie tabeli produktow
            scope.populateProductCategories = function (a1, a2, defaultValue) {
                var arr = (a1 || a2).slice();
                return arr;
            };
            //pobranie wszystkich produktów
            scope.allProducts = {};
            scope.getAllProducts = function () {
                _this.$service.getAllProducts().then(function (d) {
                    scope.allProducts = d.data;
                });
            };
            scope.getCategoriesForProduct = function (item) {
                _this.$service.getCategories(item.Name).then(function (d) {
                    item.Categories = d.data;
                });
            };
            // watchers
            scope.$watch('Request.RequestItems', function (n, o) {
                if (n !== o)
                    scope.updateTotals();
            }, true);
            scope.getAllProducts();
            // zmienne 
            scope.NetValueTotal = 0;
            scope.TaxValueTotal = 0;
            scope.GrossValueTotal = 0;
            scope.selectedProduct = {};
        };
    }
    RequestFormDirective.Factory = function () {
        var dir = function (RequestService) { return new RequestFormDirective(RequestService); };
        dir.$inject = ['RequestService'];
        return dir;
    };
    return RequestFormDirective;
}());
var RequestService = (function () {
    function RequestService($http) {
        var _this = this;
        this.$http = $http;
        this.getProductData = function (id) {
            var url = "/ProcessOfferByPartner/GetProductData";
            return _this.$http.post(url, { productId: id });
        };
        this.getAllProducts = function () {
            var url = "/ProcessOfferByPartner/GetProductList";
            return _this.$http.post(url);
        };
        this.getCategories = function (itemName) {
            var url = "/ProcessOfferByPartner/GetProductCatgories";
            return _this.$http.post(url, { filter: itemName });
        };
    }
    RequestService.prototype.destruct = function () {
        this.$http = null;
    };
    RequestService.$inject = ['$http'];
    return RequestService;
}());
// funcja konwersji string/number na number
function getAsNumber(val) {
    if (typeof val === "string") {
        return parseFloat(val);
    }
    return val;
}
;
// dyrektywa formatujaca liczby
var NumberDirective = (function () {
    function NumberDirective($parse) {
        var _this = this;
        this.$parse = $parse;
        this.restrict = "A";
        this.require = "ngModel";
        this.formatAsNumber = function (val) {
            var _val = "0,00";
            if (typeof val === "string") {
                _val = (val || "0,00");
            }
            else if (typeof val !== "undefined") {
                _val = (val || 0).toFixed(2);
            }
            _val = _val.replace(".", ",").replace(" ", "");
            // sprawdzenie liczy miejsc dziesietnych
            var pos = _val.indexOf(",");
            if (pos === -1)
                _val += ",00";
            var diff = _val.length - pos;
            if (diff >= 3) {
                _val = _val.substring(0, pos + 3);
            }
            else {
                for (var i = 0; i < diff; i++) {
                    _val += "0";
                }
            }
            //console.debug("formatAsNumber", val, _val);
            return _val;
        };
        this.parseAsNumber = function (val) {
            //console.debug("parseAsNumber", val);
            var _val = "0";
            if (typeof val === "string") {
                _val = (val || "0").replace(",", ".").replace(" ", "");
            }
            else if (typeof val !== "undefined") {
                _val = (val || 0).toFixed(2);
            }
            var __val = parseFloat(_val);
            return _this.formatDecimals(__val);
        };
        this.formatDecimals = function (val) {
            var _num = val.toFixed(2);
            return parseFloat(_num);
        };
        this.link = function (scope, elem, attr, model) {
            model.$parsers.push(_this.parseAsNumber);
            model.$formatters.push(_this.formatAsNumber);
            // dodanie formatowania liczby
            elem.attr("step", "0.01");
            elem.css("text-align", "right");
            //console.debug(attr);
            /*
            17 + 65 - ctrl+a
            46 - delete
            8 - backspace
            17 + 88 - ctrl+x
            17 + 86 - ctrl+v
            37 - arrow left
            39 - arrow right
            45 - minus
            44 - coma
            48-57 - upper 0..9
            110 - coma - numeric
            96 - 105 - 0..9 - numeric
            109 - minus - numeric
            */
            elem.bind("blur", function (evt) {
                var getter = _this.$parse(attr["ngModel"]);
                var val = getter(scope);
                var valStr = (val ? val.toFixed(2).replace(".", ",").replace(" ", "") : "0,00");
                $(evt.target).val(valStr);
            });
            elem.bind("keypress", function (evt) {
                var _keyCode = parseInt(evt.keyCode || evt.which);
                var _key = (evt.key || "").toLowerCase();
                //console.debug(_keyCode);
                //if ((48 <= _keyCode && _keyCode <= 57) || [44, 45].indexOf(_keyCode) !== -1) {
                //if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ",", "-", "delete", "backspace", "tab", "arrowright", "arrowleft", "arrowup", "arrowdown"].indexOf(_key) !== -1) {
                if ([48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 44, 45].indexOf(_keyCode) !== -1
                    || ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ",", "-", "delete", "backspace", "tab", "arrowright", "arrowleft", "arrowup", "arrowdown"].indexOf(_key) !== -1) {
                }
                else {
                    evt.preventDefault();
                    return;
                }
            });
        };
    }
    NumberDirective.Factory = function () {
        var dir = function ($parse) { return new NumberDirective($parse); };
        dir.$inject = ['$parse'];
        return dir;
    };
    return NumberDirective;
}());
// autocomplete
var AutoCompleteDirective = (function () {
    function AutoCompleteDirective($parse, $http, $filterFilter) {
        var _this = this;
        this.$parse = $parse;
        this.$http = $http;
        this.$filterFilter = $filterFilter;
        this.scope = {
            ngModel: "=",
            ngRequired: "=",
            ngDisabled: "=",
            url: "@",
            filterLocal: "@",
            valueField: "@",
            filter: "=",
            onSelect: "=",
            onSelectRef: "="
        };
        this.require = ['ngModel'];
        this.replace = true;
        this.template = "\n    <div class=\"autocomplete\" id=\"{{id}}\">\n    <input autocomplete=\"_{{name}}\" ng-keydown=\"onKeyPressed($event)\" type=\"text\" class=\"autocomplete-input {{class}}\" name=\"{{name}}\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel\" ng-required=\"ngRequired\" ng-disabled=\"ngDisabled\"/>\n    <div class=\"autocomplete-list\" ng-show=\"showAutocomplete\">\n    <ul>\n    <li ng-class=\"{'selected' : (matchValue(v))}\" ng-click=\"onSelectValue(v)\" ng-repeat=\"v in filteredData\">{{getValueFiled(v)}}</li>\n    </ul>\n    </div>\n    </div>\n    ";
        this.restrict = "A";
        this.link = function (scope, elem, attr) {
            //console.debug("AutoCompleteDirective");
            // zmienne
            scope.showAutocomplete = false;
            scope.isFiltering = false;
            scope.currentValue = undefined;
            // parametry
            scope.id = attr['id'] || (new Date()).getTime();
            scope.name = attr['name'];
            scope.class = attr['class'];
            scope.placeholder = attr['placeholder'];
            scope.filteredData = [];
            scope.data = [];
            // przefiltorwane dane
            scope.$watch('data', function () {
                scope.filteredData = _this.$filterFilter(scope.data, scope.filterData);
            });
            // filtowanie lokalne
            if (scope.filterLocal) {
                scope.$watch('ngModel', function (n, o) {
                    if (n !== o && scope.isFiltering === true) {
                        scope.filteredData = _this.$filterFilter(scope.data, scope.filterData);
                    }
                }, true);
            }
            // nacisineicie enter
            scope.onKeyPressed = function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    // pobranie danych
                    if (scope.showAutocomplete === false) {
                        scope.showAutocomplete = true;
                        var filter = (scope.filter);
                        var url = scope.url;
                        _this.$http.post(url, { filter: filter }).then(function (d) {
                            scope.data = d.data;
                        });
                    }
                    else {
                        scope.showAutocomplete = false;
                        scope.onSelectValue(scope.currentValue);
                    }
                }
                else if (e.keyCode === 38) {
                    // do gory
                    if (scope.showAutocomplete === true) {
                        e.preventDefault();
                        scope.isFiltering = false;
                        var pos = scope.filteredData.indexOf(scope.currentValue);
                        if (pos > 0) {
                            pos--;
                        }
                        else {
                            pos = 0;
                        }
                        scope.currentValue = scope.filteredData[pos];
                        scope.ngModel = scope.getValueFiled(scope.currentValue);
                    }
                }
                else if (e.keyCode === 40) {
                    // do dołu
                    if (scope.showAutocomplete === true) {
                        e.preventDefault();
                        scope.isFiltering = false;
                        var pos = scope.filteredData.indexOf(scope.currentValue);
                        if (pos < scope.filteredData.length - 1) {
                            pos++;
                        }
                        else {
                            pos = scope.filteredData.length - 1;
                        }
                        scope.currentValue = scope.filteredData[pos];
                        scope.ngModel = scope.getValueFiled(scope.currentValue);
                    }
                }
                else if (e.keyCode === 27) {
                    // ESC
                    e.preventDefault();
                    scope.showAutocomplete = false;
                }
                else {
                    if (scope.filterLocal) {
                        scope.isFiltering = true;
                    }
                }
            };
            // wybranie pozycji
            scope.onSelectValue = function (v) {
                scope.currentValue = v;
                scope.ngModel = scope.getValueFiled(scope.currentValue);
                scope.showAutocomplete = false;
                // delegacja wyboru
                if (typeof scope.onSelect === "function" && typeof scope.onSelectRef !== "undefined") {
                    scope.onSelect(scope.onSelectRef, v);
                }
            };
            // sprawdzenie
            scope.matchValue = function (v) {
                return v === scope.currentValue;
            };
            // pobranie pola do rawrotsci
            scope.getValueFiled = function (v) {
                if (scope.valueField && v) {
                    return v[scope.valueField]; //
                }
                return v;
            };
            // filtr
            scope.filterData = function (v) {
                if (scope.filterLocal && scope.isFiltering === true) {
                    var v0 = (scope.getValueFiled(v) || "").trim().toLowerCase();
                    var v1 = (scope.ngModel || "").trim().toLowerCase();
                    if (v1 !== "" && v0.indexOf(v1) === -1)
                        return false;
                }
                return true;
            };
        };
    }
    AutoCompleteDirective.Factory = function () {
        var dir = function ($parse, $http, $filterFilter) { return new AutoCompleteDirective($parse, $http, $filterFilter); };
        dir['$inject'] = ['$parse', '$http', 'filterFilter'];
        return dir;
    };
    return AutoCompleteDirective;
}());
/**
 * Dyrektywa do implementacji niestandardowych reguł walidacyjnych.
 * Należy pamiętać, że wszystkie podformatki muszą mieć unikalne nazwy.
 * Dyrektywa musi być zagnieżdżona wewnątrz elementu <form>
 * successCallback to zwykle metoda, którą wykonywał ng-click, wywoływana, jeśli formatka jest OK
 * Więc przycisk submit formatki musi być klikalny, nie disabled (o to dba successCallback).
 */
var FormValidationDirective = (function () {
    function FormValidationDirective() {
        this.restrict = "AE";
        this.require = "^form";
        this.scope = {
            successCallback: "="
        };
        this.template = "\n    <ul class='ll-form-validation-list'>\n        <li ng-repeat='error in errors'>\n            {{error}}\n        </li>\n    </ul>";
        this.link = function (scope, elem, attrs, ctrl) {
            scope.errors = {}; // set błędów
            scope.user = scope.$root.user;
            // dodanie klasy CSS do formatki
            var el = angular.element(elem);
            var type = el[0].nodeName;
            while (type != 'FORM') {
                el = el.parent();
                type = el[0].nodeName;
            }
            el.addClass('ll-form-validation');
            /**
             * Funkcja rekurencyjna pomocnicza, iterująca po wszystkich inputach formatki, a także
             * formatek zagnieżdżonych.
             * @param form Formatka do sprawdzenia.
             * @param errors Set wykrytych błędów. Jeśli nie podany to zostanie automatycznie stworzony.
             * @returns Errors z uzupełnionymi błędami.
             */
            scope.iterValidationOverForm = function (form, errors) {
                if (typeof errors === "undefined")
                    errors = {};
                angular.forEach(Object.keys(form), function (key) {
                    if (typeof form[key] === 'object') {
                        if (form[key].hasOwnProperty('$modelValue')) {
                            SetValidityForName(form[key], errors, form.$name);
                        }
                        else if (form[key].hasOwnProperty('$$parentForm') && key !== '$$parentForm') {
                            scope.iterValidationOverForm(form[key], errors);
                        }
                    }
                });
                return errors;
            };
            /**
             * Funkcja lokalna przypisująca reguły walidacyjne w zależności od nazwy inputu.
             * Jeśli dyrektywa ma być używa na nowych formatkach, należy zadbać o dodanie
             * w tej funkcji nazw inputów, które chcemy obsłużyć.
             * @param formValue Input formatki.
             * @param errors Set błędów.
             * @returns True, jeśli input jest $valid, False w przeciwnym przypadku lub jeśli
             * nie znaleziono takiego zdefiniowanego pola.
             */
            var SetValidityForName = function (formValue, errors, formName) {
                var modelValue = formValue.$modelValue;
                var valueName = formValue.$name;
                switch (valueName) {
                    case 'IdentificationNumber1':
                        var isNipOk = formValue.$valid;
                        if (!isNipOk)
                            errors[valueName] = "Nieprawidłowy NIP.";
                        break;
                    case 'SaveDataEmail':
                        var isEmailOk = formValue.$valid;
                        if (!isEmailOk)
                            errors[valueName] = "Nieprawidłowy adres e-mail.";
                        break;
                    case 'SaveDataPhone':
                        var isPhoneOk = formValue.$valid;
                        if (!isPhoneOk)
                            errors[valueName] = "Nieprawidłowy numer telefonu.";
                        break;
                    case 'SaveDataContactPerson':
                        var isSaveDataContactPersonOK = formValue.$valid;
                        if (!isSaveDataContactPersonOK)
                            errors[valueName] = "Nieprawidłowy imię i nazwisko Handlowca.";
                        break;
                    case 'Name':
                        var isNameOk = formValue.$valid;
                        if (!isNameOk)
                            errors[valueName] = "Nieprawidłowa nazwa przedmiotu.";
                        break;
                    case 'CategoryLevel1':
                        var isCategoryOk = formValue.$valid;
                        if (!isCategoryOk)
                            errors[valueName] = "Wybierz kategorię przedmiotu.";
                        break;
                    case 'TaxCode':
                        var isTaxOk = formValue.$valid;
                        if (!isTaxOk)
                            errors[valueName] = "Nieprawidłowy kod podatku.";
                        break;
                    case 'NetValue':
                        // if (!scope.checkNetValue) break; // omijanie sprawdzania wartości
                        if (checkIfExcluded(valueName, formName)) {
                            formValue.$setValidity(valueName, true);
                            break;
                        }
                        var maxValue = (scope.user && ['DHMLEA', 'CCMLEA'].indexOf(scope.user.ExternalId) !== -1 ? 50000 : 100000);
                        var isNetValueOk = modelValue <= maxValue;
                        formValue.$setValidity(valueName, isNetValueOk);
                        //if (!isNetValueOk) errors[valueName] = "Nieprawidłowa wartość przedmiotu. LEASELINK finansuje przedmioty od wartości 500 zł do 100000 zł netto.";
                        if (!isNetValueOk)
                            errors[valueName] = "Nieprawid\u0142owa warto\u015B\u0107 przedmiotu. LEASELINK finansuje przedmioty do warto\u015Bci " + maxValue + " z\u0142 netto.";
                        break;
                    case 'Quantity':
                        var isQuantityOk = modelValue > 0;
                        formValue.$setValidity(valueName, isQuantityOk);
                        if (!isQuantityOk)
                            errors[valueName] = "Ilość musi być większa od 0.";
                        break;
                    case 'Agreed':
                        var isAgreedOk = modelValue === true;
                        formValue.$setValidity(valueName, isAgreedOk);
                        if (!isAgreedOk)
                            errors[valueName] = "Prosimy o wyrażenie zgód niezbędnych dla procesu. Brak Twojej zgody uniemożliwi nam kontakt z Tobą, a także dalsze realizowanie wniosku.";
                        break;
                    default:
                        return;
                }
            };
            /**
             * Sprawdzenie czy pole ma atrybut 'validation-exclude' i zwrócenie jej wartości jako boolean.
             * @param name Nazwa (name) pola do sprawdzenia.
             * @param formName Nazwa rodzica (name), musi być ng-form albo form.
             * @returns True, jeśli pole ma atrybut 'validation-exclude' ustawione na true.
             * W każdym innym przypadku false.
             */
            var checkIfExcluded = function (name, formName) {
                var elem = document.querySelector('ng-form[name=' + formName + '] > ' + 'input[name=' + name + ']');
                if (!elem)
                    elem = document.querySelector('form[name=' + formName + '] > ' + 'input[name=' + name + ']');
                if (elem && elem.attributes['validation-exclude'])
                    return elem.attributes['validation-exclude'].value.toLowerCase() == 'true';
                return false;
            };
            // pierwsze sprawdzenie, po wyrenderowaniu DOM, dlatego $timeout
            // this.$timeout(() => {
            //     scope.errors = scope.iterValidationOverForm(ctrl);
            // });
            // sprawdzamy czy do wysłania - jeśli tak, to sprawdzamy poprawność formatki
            scope.$watch(function () { return ctrl.$submitted; }, function (newVal, oldVal) {
                if (newVal) {
                    scope.errors = scope.iterValidationOverForm(ctrl);
                    if (ctrl.$valid)
                        scope.successCallback();
                    ctrl.$setPristine();
                }
            });
        };
    }
    FormValidationDirective.Factory = function () {
        var dir = function (toaster, $timeout) { return new FormValidationDirective(); };
        dir['$inject'] = [];
        return dir;
    };
    return FormValidationDirective;
}());
// scroll watcher
var ngScrollWatcherDirective = (function () {
    function ngScrollWatcherDirective() {
        this.restrict = "A";
        this.link = function (scope, elem, attr) {
        };
    }
    ngScrollWatcherDirective.Factory = function () {
        var d = function () { return new ngScrollWatcherDirective(); };
        d['$inject'] = [];
        return d;
    };
    return ngScrollWatcherDirective;
}());
var clientConsents;
(function (clientConsents) {
    var ClientConsentsSrv = (function () {
        function ClientConsentsSrv($http) {
            var _this = this;
            this.$http = $http;
            // pobranie zestawu zgod
            this.getConsentList = function (partner, processStage) {
                var url = '/api/RodoConstent?type=';
                if (partner) {
                    url += '&partner=' + (partner);
                }
                if (processStage) {
                    url += '&processStage=' + (processStage);
                }
                return _this.$http.get(url);
            };
            // pobranie zgod na procesie
            this.getProcessConsents = function (orderId) {
                var url = '/api/get-rodo-consent-for-offer?orderId=' + orderId;
                return _this.$http.get(url);
            };
        }
        ClientConsentsSrv.$inject = ['$http'];
        return ClientConsentsSrv;
    }());
    clientConsents.ClientConsentsSrv = ClientConsentsSrv;
    var ClientConsentsCtrl = (function () {
        function ClientConsentsCtrl($scope, $service) {
            var _this = this;
            this.$service = $service;
            // pobranie danych
            $scope.refresh = function () {
                // pobranie stage
                var partner = $scope.formRequest.PartnerName || 'LEASELINK';
                // // chwilowa klazula na wyłączność
                // if (['BOSBANK', 'ING-BANK'].indexOf(partner.toUpperCase()) === -1) {
                //     partner = 'LEASELINK';
                // }
                //const partner = 'LEASELINK';
                var stage = $scope.step;
                _this.$service.getConsentList(partner, stage).then(function (d) {
                    $scope.consents = d.data.Result;
                }, function (e) { });
                // pobranie zgód rodo 
                _this.$service.getProcessConsents($scope.formRequest.AggragatedCalulationId).then(function (d) {
                    $scope.processConsents = d.data.Result;
                }, function (e) { });
            };
            $scope.initCheckbox = function (consentGuid) {
                var consentInitialValue = false;
                for (var i = 0; i <= $scope.formRequest.Requestors[0].Consents.length - 1; i++) {
                    var _processConsent = $scope.formRequest.Requestors[0].Consents[i];
                    if (_processConsent.Guid === consentGuid) {
                        if (_processConsent.Agreed) {
                            consentInitialValue = true;
                        }
                        else {
                            consentInitialValue = false;
                        }
                    }
                }
                return { Agreed: consentInitialValue, isCollapsed: false };
            };
            // obserwacja zmian
            $scope.$watch('consentsModel', function (n, o) {
                var keys = Object.keys(n);
                for (var i = 0; i <= keys.length - 1; i++) {
                    var key = keys[i];
                    var consent = n[key];
                    var found = false;
                    for (var j = 0; j <= $scope.formRequest.Requestors[0].Consents.length - 1; j++) {
                        var _consent = $scope.formRequest.Requestors[0].Consents[j];
                        if (_consent.Guid === key) {
                            _consent.Agreed = consent.Agreed;
                            found = true;
                            break;
                        }
                    }
                    if (found !== true) {
                        $scope.formRequest.Requestors[0].Consents.push({
                            Guid: key,
                            Agreed: consent.Agreed
                        });
                    }
                }
            }, true);
            // obserwacja forma
            $scope.$watch('formRequest', function () {
                if ($scope.formRequest && $scope.formRequest.Requestors && $scope.formRequest.Requestors.length > 0) {
                    $scope.formRequest.Requestors[0].Consents = $scope.formRequest.Requestors[0].Consents || [];
                    $scope.refresh();
                }
            });
            // zmiana check all
            $scope.$watch('checkAll', function () {
                var keys = Object.keys($scope.consentsModel);
                for (var i = 0; i <= keys.length - 1; i++) {
                    var _key = keys[i];
                    $scope.consentsModel[_key].Agreed = ($scope.checkAll === true);
                }
            });
            // zmiana check all
            $scope.$watch('selectAll', function () {
                var keys = Object.keys($scope.consentsModel);
                for (var i = 0; i <= keys.length - 1; i++) {
                    var _key = keys[i];
                    $scope.consentsModel[_key].Agreed = ($scope.selectAll === true);
                }
            });
            // lista zgód
            $scope.consents = [];
            $scope.processConsents = [];
            $scope.consentsModel = {};
            $scope.selectAll = false;
        }
        ClientConsentsCtrl.$inject = ['$scope', 'ClientConsentsSrv'];
        return ClientConsentsCtrl;
    }());
    clientConsents.ClientConsentsCtrl = ClientConsentsCtrl;
    var ClientConsentsDir = (function () {
        function ClientConsentsDir() {
            this.restrict = "AE";
            this.template = "\n        <div ng-show=\"consents.length > 0\" class=\"client-consents-container\">\n        <table class=\"dane\">\n        <tr>\n            <td>\n            <div ng-show=\"consents.length > 1\">\n                <label class=\"checkbox-inline\" for=\"selectAll\">\n                    <input name=\"selectAll\" id=\"selectAll\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"selectAll\" ng-checked=\"selectAll\" />\n                    <span>Zaznacz wszystkie</span>\n                </label>\n            </div>\n\n            <div  ng-repeat=\"consent in consents\" class=\"client-consent-container\">\n            <ng-form name=\"consentForm\">\n                <label class=\"checkbox-inline\" for=\"Agreed\" style=\"\" ng-init=\"consentsModel[consent.Guid] = { Agreed: false , isCollapsed: false }\">\n                    <input name=\"Agreed\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"consentsModel[consent.Guid].Agreed\" ng-checked=\"consentsModel[consent.Guid].Agreed\" ng-required=\"consent.Obligatory === true\" class=\"\">\n                    <span class=\"req\" ng-show=\"consentForm.Agreed.$error.required\" style=\"margin-right: 5px;\">Niezb\u0119dne *</span>\n                    <span>{{consent.Code}}</span>\n                    <a class=\"show-more\" ng-click=\"consentsModel[consent.Guid].isCollapsed = !consentsModel[consent.Guid].isCollapsed\">Zobacz pe\u0142n\u0105 tre\u015B\u0107 \u00BB</a>\n                </label>\n\n                <div collapse=\"consentsModel[consent.Guid].isCollapsed !== true\" class=\"in\" style=\"height: auto;\">\n                    <div class=\"well well-sm\" ng-bind-html=\"consent.Text\"></div>\n                </div>\n            </ng-form>\n            </div>\n\n            </td>\n        </tr>\n        </table>\n        <div ng-show=\"!simpleForm\" class=\"rodo-add-info\">*Prosimy o wyra\u017Cenie zg\u00F3d na kontakt niezb\u0119dnych dla realizacji Twojej oferty. Ze wzgl\u0119du na ca\u0142kowicie on-lineowy charakter naszego procesu, od poznania oferty, a\u017C po zawarcie transakcji, brak Twojej zgody uniemo\u017Cliwi nam spe\u0142nienie Twoich potrzeb w ci\u0105gu kilku minut, 24/7/365. Podanie numeru NIP, numeru telefonu oraz adresu e-mail nie jest wymogiem ustawowym, jednak\u017Ce jest wymagane je\u015Bli chc\u0105 Pa\u0144stwo skorzysta\u0107 z naszych us\u0142ug.</div>\n        </div>\n        ";
            this.controller = ClientConsentsCtrl;
            this.scope = {
                step: "@",
                formRequest: "=",
                checkAll: "=",
                simpleForm: "=" // ukrywa napis pod zgodami
            };
        }
        ClientConsentsDir.Factory = function () {
            var d = function () { return new ClientConsentsDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsDir;
    }());
    clientConsents.ClientConsentsDir = ClientConsentsDir;
    var ClientConsentsNewDir = (function () {
        function ClientConsentsNewDir() {
            this.restrict = "AE";
            this.template = "\n        <div class=\"client-consents-container\">\n        <table class=\"dane\">\n        <tr>\n            <td>\n\n            <label class=\"checkbox-inline\" for=\"selectAll\">\n                <input name=\"selectAll\" id=\"selectAll\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"selectAll\" ng-checked=\"selectAll\" />\n                <span>Zaznacz wszystkie</span>\n            </label>\n\n            <div  ng-repeat=\"consent in consents\" class=\"client-consent-container\">\n            <ng-form name=\"consentForm\">\n                <label class=\"checkbox-inline\" for=\"Agreed\" style=\"\" ng-init=\"consentsModel[consent.Guid] = { Agreed: false , isCollapsed: false }\">\n                    <input name=\"Agreed\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"consentsModel[consent.Guid].Agreed\" ng-checked=\"consentsModel[consent.Guid].Agreed\" ng-required=\"consent.Obligatory === true\" class=\"\">\n                    <span class=\"req\" ng-show=\"consentForm.Agreed.$error.required\" style=\"margin-right: 5px;\">Niezb\u0119dne *</span>\n                    <span>{{consent.Code}}</span>\n                    <a class=\"show-more\" ng-click=\"consentsModel[consent.Guid].isCollapsed = !consentsModel[consent.Guid].isCollapsed\">Zobacz pe\u0142n\u0105 tre\u015B\u0107 \u00BB</a>\n                </label>\n\n                <div collapse=\"consentsModel[consent.Guid].isCollapsed !== true\" class=\"in\" style=\"height: auto;\">\n                    <div class=\"well well-sm\" ng-bind-html=\"consent.Text\"></div>\n                </div>\n            </ng-form>\n            </div>\n\n            </td>\n        </tr>\n        </table>\n        <div class=\"rodo-add-info\">*Prosimy o wyra\u017Cenie zg\u00F3d na kontakt niezb\u0119dnych dla realizacji oferty Klienta. Ze wzgl\u0119du na ca\u0142kowicie on-lineowy charakter naszego procesu, od poznania oferty, a\u017C po zawarcie transakcji, brak zgody uniemo\u017Cliwi nam spe\u0142nienie jego potrzeb w ci\u0105gu kilku minut, 24/7/365. Podanie numeru NIP, numeru telefonu oraz adresu e-mail nie jest wymogiem ustawowym, jednak\u017Ce jest wymagane je\u015Bli chc\u0105 Pa\u0144stwo skorzysta\u0107 z naszych us\u0142ug. Klient w dowolnej chwili mo\u017Ce usun\u0105\u0107 swoje zgody.</div>\n\n        </div>\n        ";
            this.controller = ClientConsentsCtrl;
            this.scope = {
                step: "@",
                formRequest: "=",
                checkAll: "="
            };
        }
        ClientConsentsNewDir.Factory = function () {
            var d = function () { return new ClientConsentsNewDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsNewDir;
    }());
    clientConsents.ClientConsentsNewDir = ClientConsentsNewDir;
    var ClientConsentsInnerDir = (function () {
        function ClientConsentsInnerDir() {
            this.restrict = "AE";
            this.template = "\n\n        <div  ng-repeat=\"consent in consents\" class=\"client-consent-container\">\n        <ng-form name=\"consentForm\">\n            <label class=\"checkbox-inline\" for=\"Agreed\" style=\"font-weight: bold;\" ng-init=\"consentsModel[consent.Guid] = initCheckbox(consent.Guid)\">\n                <input name=\"Agreed\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"consentsModel[consent.Guid].Agreed\" ng-checked=\"consentsModel[consent.Guid].Agreed\" ng-required=\"consent.Obligatory === true\" class=\"\">\n                <span class=\"req\" ng-show=\"consentForm.Agreed.$error.required\" style=\"margin-right: 5px;\">Niezb\u0119dne *</span>\n                <span>{{consent.Code}}</span>\n                <a class=\"show-more\" ng-click=\"consentsModel[consent.Guid].isCollapsed = !consentsModel[consent.Guid].isCollapsed\">Zobacz pe\u0142n\u0105 tre\u015B\u0107 \u00BB</a>\n            </label>\n\n            <div collapse=\"consentsModel[consent.Guid].isCollapsed !== true\" class=\"in\" style=\"height: auto;\">\n                <div class=\"well well-sm\" ng-bind-html=\"consent.Text\"></div>\n            </div>\n        </ng-form>\n        </div>\n\n\n        ";
            this.controller = ClientConsentsCtrl;
            this.scope = {
                step: "@",
                formRequest: "=",
                checkAll: "="
            };
        }
        ClientConsentsInnerDir.Factory = function () {
            var d = function () { return new ClientConsentsInnerDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsInnerDir;
    }());
    clientConsents.ClientConsentsInnerDir = ClientConsentsInnerDir;
    var ClientConsentsInfoDir = (function () {
        function ClientConsentsInfoDir() {
            this.template = "\n        <div class=\"rodo-info-container\">\n            <div class=\"content\">\n                <a target=\"_blank\" href=\"https://leaselink.pl/obowiazek-informacyjny\">RODO - Obowi\u0105zek informacyjny.</a>\n            </div>\n        </div>\n        ";
        }
        ClientConsentsInfoDir.Factory = function () {
            var d = function () { return new ClientConsentsInfoDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsInfoDir;
    }());
    clientConsents.ClientConsentsInfoDir = ClientConsentsInfoDir;
})(clientConsents || (clientConsents = {}));
angular.module("ll.client.consents", ['ngSanitize'])
    .directive("llClientConsents", clientConsents.ClientConsentsDir.Factory())
    .directive("llClientConsentsNew", clientConsents.ClientConsentsNewDir.Factory())
    .directive("llClientConsentsInner", clientConsents.ClientConsentsInnerDir.Factory())
    .directive("llClientConsentsInfo", clientConsents.ClientConsentsInfoDir.Factory())
    .service("ClientConsentsSrv", clientConsents.ClientConsentsSrv);
var clientDirectives;
(function (clientDirectives) {
    /** process stage */
    var ngProcessMultiStepsCtrl = (function () {
        function ngProcessMultiStepsCtrl($scope) {
            //zmienne
            $scope.numberOfSteps = ($scope.partner && $scope.userLogged) ? 6 : 5;
            $scope.currentStep = 0;
            $scope.isVisible = false;
            $scope.partnerPosition = (($scope.partner && $scope.userLogged) ? 'top' : 'bottom');
            if ($scope.position && $scope.position == $scope.partnerPosition) {
                $scope.isVisible = true;
            }
            else if (!$scope.position) {
                $scope.isVisible = true;
            }
            else {
                $scope.isVisible = false;
            }
            // przemapowanie krokow
            switch ($scope.step) {
                case "step0":
                    $scope.currentStep = 0;
                    break;
                case "step1":
                    $scope.currentStep = 1;
                    break;
                case "step2":
                    $scope.currentStep = 2;
                    break;
                case "step3":
                    $scope.currentStep = 3;
                    break;
                case "step4":
                    $scope.currentStep = 4;
                    break;
                case "step5":
                    $scope.currentStep = 5;
                    break;
            }
        }
        ngProcessMultiStepsCtrl.$inject = ['$scope'];
        return ngProcessMultiStepsCtrl;
    }());
    var ngProcessMultiSteps = (function () {
        function ngProcessMultiSteps() {
            this.controller = ngProcessMultiStepsCtrl;
            this.restrict = "AE";
            this.scope = {
                step: "@",
                partner: "=",
                position: "@",
                userLogged: "="
            };
            this.templateUrl = "/WWW/partials/process.steps.directive.html";
        }
        ngProcessMultiSteps.Factory = function () {
            var dir = function () { return new ngProcessMultiSteps(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngProcessMultiSteps;
    }());
    clientDirectives.ngProcessMultiSteps = ngProcessMultiSteps;
    /** side up drawer */
    var ngProcessSideDrawerCtrl = (function () {
        function ngProcessSideDrawerCtrl($scope) {
            $scope.showDrawer = function () {
                $scope.isDrawerVisible = true;
            };
            $scope.closeDrawer = function () {
                $scope.isDrawerVisible = false;
            };
            // zmienne
            $scope.isDrawerVisible = false;
            // czy wogole dostepy
            $scope.isDrawerAvaiable = ($scope.userLogged && $scope.partner) || false; // ['MEDMRK'].indexOf($scope.partner) !== -1;
        }
        ngProcessSideDrawerCtrl.$inject = ['$scope'];
        return ngProcessSideDrawerCtrl;
    }());
    var ngProcessSideDrawer = (function () {
        function ngProcessSideDrawer() {
            this.controller = ngProcessSideDrawerCtrl;
            this.restrict = "AE";
            this.replace = true;
            this.scope = {
                step: "@",
                partner: "=",
                userLogged: "="
            };
            this.templateUrl = "/WWW/partials/modules/process.drawer.directive.html";
        }
        ngProcessSideDrawer.Factory = function () {
            var dir = function () { return new ngProcessSideDrawer(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngProcessSideDrawer;
    }());
    clientDirectives.ngProcessSideDrawer = ngProcessSideDrawer;
    /** koszyk na createoffer */
    var ngCreateOfferCartCtrl = (function () {
        function ngCreateOfferCartCtrl($scope) {
        }
        ngCreateOfferCartCtrl.$inject = ['$scope'];
        return ngCreateOfferCartCtrl;
    }());
    var ngCreateOfferCart = (function () {
        function ngCreateOfferCart() {
            this.controller = ngCreateOfferCartCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/client.offer/create.offer.cart.html";
        }
        ngCreateOfferCart.Factory = function () {
            var dir = function () { return new ngCreateOfferCart(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngCreateOfferCart;
    }());
    clientDirectives.ngCreateOfferCart = ngCreateOfferCart;
    /** koszyk stacjonarny na createoffer */
    var ngCreateOfferCartStationaryCtrl = (function () {
        function ngCreateOfferCartStationaryCtrl($scope) {
        }
        ngCreateOfferCartStationaryCtrl.$inject = ['$scope'];
        return ngCreateOfferCartStationaryCtrl;
    }());
    var ngCreateOfferCartStationary = (function () {
        function ngCreateOfferCartStationary() {
            this.controller = ngCreateOfferCartStationaryCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/client.offer/create.offer.cart.stationary.html";
        }
        ngCreateOfferCartStationary.Factory = function () {
            var dir = function () { return new ngCreateOfferCartStationary(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngCreateOfferCartStationary;
    }());
    clientDirectives.ngCreateOfferCartStationary = ngCreateOfferCartStationary;
    /** dane klienta na createOffer */
    var ngCreateOfferClientDataCtrl = (function () {
        function ngCreateOfferClientDataCtrl($scope) {
        }
        ngCreateOfferClientDataCtrl.$inject = ['$scope'];
        return ngCreateOfferClientDataCtrl;
    }());
    var ngCreateOfferClientData = (function () {
        function ngCreateOfferClientData() {
            this.controller = ngCreateOfferClientDataCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/client.offer/create.offer.client.data.html";
        }
        ngCreateOfferClientData.Factory = function () {
            var dir = function () { return new ngCreateOfferClientData(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngCreateOfferClientData;
    }());
    clientDirectives.ngCreateOfferClientData = ngCreateOfferClientData;
    /** edycja elementow */
    /** edycja dnaych klienta*/
    var ngClientDataCtrl = (function () {
        function ngClientDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
            };
            $scope.saveData = function () {
                $scope.isEdited = false;
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            // zmienne
            $scope.isEdited = false;
        }
        ngClientDataCtrl.$inject = ['$scope'];
        return ngClientDataCtrl;
    }());
    var ngClientData = (function () {
        function ngClientData() {
            this.controller = ngClientDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.data.html";
        }
        ngClientData.Factory = function () {
            var d = function () { return new ngClientData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientData;
    }());
    clientDirectives.ngClientData = ngClientData;
    /** edycja danych adresowych klienta*/
    var ngClientAddressDataCtrl = (function () {
        function ngClientAddressDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorAddresses[0].Confirmed = false;
            };
            $scope.confirm = function () {
                $scope.request.RequestorAddresses[0].Confirmed = true;
            };
            // ustawienie informacji o adresie korespondecyjnym 
            $scope.request.RequestorAddresses[0].Required = true;
            // zapisanie danych
            $scope.saveData = function () {
                $scope.isEdited = false;
                // ustawienie informacji o adresie korespondecyjnym 
                $scope.request.RequestorAddresses[0].Required = true;
                // zapisanie danych
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            // zmienne
            $scope.isEdited = false;
        }
        ngClientAddressDataCtrl.$inject = ['$scope'];
        return ngClientAddressDataCtrl;
    }());
    var ngClientAddressData = (function () {
        function ngClientAddressData() {
            this.controller = ngClientAddressDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.address.data.html";
        }
        ngClientAddressData.Factory = function () {
            var d = function () { return new ngClientAddressData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientAddressData;
    }());
    clientDirectives.ngClientAddressData = ngClientAddressData;
    var ngClientDocumentsDataSrv = (function () {
        function ngClientDocumentsDataSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.getDocuments = function (id, type) {
                var url = '/api/SecuredBusinessProcessDocumentsForUser/' + id + '?type=' + type;
                return _this.$http.get(url);
            };
            this.sendConfirmation = function (id, fileIds) {
                var url = "/document/confirm/" + id;
                return _this.$http.post(url, fileIds);
            };
        }
        ngClientDocumentsDataSrv.$inject = ['$http', '$q'];
        return ngClientDocumentsDataSrv;
    }());
    clientDirectives.ngClientDocumentsDataSrv = ngClientDocumentsDataSrv;
    /** wyswietlanie dokumentow */
    var ngClientDocumentsDataCtrl = (function () {
        function ngClientDocumentsDataCtrl($rootScope, $scope, service, toaster) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            $scope.Documents = [];
            $scope.$on('selfsevice::refresh', function (evt) {
                $scope.getDocuments();
            });
            $scope.getDocuments = function () {
                service.getDocuments($scope.request.AggragatedCalulationId, 'AGREEMENTS')
                    .then(function (d) {
                    $scope.Documents = d.data.Result || [];
                });
            };
            $scope.showDocument = function (fileId) {
                window.open("/Message/ShowDocument?fileId=" + fileId);
            };
            // wyslanie wiadomosci
            $scope.sendMessageToLeaseLink = function () {
                $rootScope.$broadcast("send::messageToLeaselink", { RequestId: $scope.request.AggragatedCalulationId });
            };
            $scope.confirmDocument = function (fileId, params) {
                var _params = params || {};
                var id = $scope.request.AggragatedCalulationId;
                var fileIds = [];
                fileIds.push(fileId);
                if ($scope.user.Role === '' || confirm("Czy na pewno chcesz potwierdzić zapoznanie się z dokumentem?")) {
                    service.sendConfirmation(id, fileIds).then(function (d) {
                        toaster.pop('success', "Potwierdzanie dokumentu", "Dokument potwierdzono poprawnie.");
                        if (_params && typeof _params.callBack === "function") {
                            _params.callBack();
                        }
                        else {
                            // pokazanie zapytania
                            $scope.showRequest(id);
                        }
                    }, function (e) {
                        toaster.pop('error', "Potwierdzanie dokumentu", "Wystąpił błąd podczas potwierdzania dokumentu.");
                    });
                }
            };
            $scope.confirmDocumentWithNoReaload = function (doc) {
                $scope.confirmDocument(doc.FileId, { callBack: function () { doc.Confirmed = true; } });
            };
            $scope.getDocuments();
        }
        ;
        ngClientDocumentsDataCtrl.$inject = ['$rootScope', '$scope', 'ngClientDocumentsDataSrv', 'toaster'];
        return ngClientDocumentsDataCtrl;
    }());
    var ngClientDocumentsData = (function () {
        function ngClientDocumentsData($rootScope) {
            this.$rootScope = $rootScope;
            this.controller = ngClientDocumentsDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                user: "=",
            };
            this.link = function (scope, elem, attr) {
            };
            this.templateUrl = "/WWW/partials/modules/request.client.documents.data.html";
        }
        ngClientDocumentsData.Factory = function () {
            var d = function ($rootScope) { return new ngClientDocumentsData($rootScope); };
            d['$inject'] = ['$rootScope'];
            return d;
        };
        return ngClientDocumentsData;
    }());
    clientDirectives.ngClientDocumentsData = ngClientDocumentsData;
    /** edycja danych adresowych podpisania umowy*/
    var ngClientDeliveryDataCtrl = (function () {
        function ngClientDeliveryDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorDeliveryAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                $scope.request.RequestorDeliveryAddress.Confirmed = true;
            };
            $scope.copy = function () {
                var address = JSON.parse(JSON.stringify($scope.request.RequestorAddresses[0]));
                address.Confirmed = false;
                $scope.request.RequestorDeliveryAddress = address;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorDeliveryAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorDeliveryAddress.Required = true;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientDeliveryDataCtrl.$inject = ['$scope'];
        return ngClientDeliveryDataCtrl;
    }());
    var ngClientDeliveryData = (function () {
        function ngClientDeliveryData() {
            this.controller = ngClientDeliveryDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.delivery.data.html";
        }
        ngClientDeliveryData.Factory = function () {
            var d = function () { return new ngClientDeliveryData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientDeliveryData;
    }());
    clientDirectives.ngClientDeliveryData = ngClientDeliveryData;
    /** edycja danych adresowych odbioru sprzętu*/
    var ngClientCollectDataCtrl = (function () {
        function ngClientCollectDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorCollectAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                if ($scope.request.TypeOfItemCollect === 1) {
                    $scope.request.RequestorCollectAddress.Required = true;
                    $scope.request.RequestorSelfCollectAddress.Required = false;
                }
                $scope.request.RequestorCollectAddress.Confirmed = true;
            };
            $scope.copy = function () {
                var address = JSON.parse(JSON.stringify($scope.request.RequestorAddresses[0]));
                address.Confirmed = false;
                $scope.request.RequestorCollectAddress = address;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorCollectAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorCollectAddress.Required = true;
                $scope.request.RequestorSelfCollectAddress.Required = false;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientCollectDataCtrl.$inject = ['$scope'];
        return ngClientCollectDataCtrl;
    }());
    var ngClientCollectData = (function () {
        function ngClientCollectData() {
            this.controller = ngClientCollectDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.collect.adress.data.html";
        }
        ngClientCollectData.Factory = function () {
            var d = function () { return new ngClientCollectData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientCollectData;
    }());
    clientDirectives.ngClientCollectData = ngClientCollectData;
    /** edycja danych adresowych odbioru sprzętu*/
    var ngClientSelfCollectDataCtrl = (function () {
        function ngClientSelfCollectDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorSelfCollectAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                if ($scope.request.TypeOfItemCollect === 0) {
                    $scope.request.RequestorCollectAddress.Required = false;
                    $scope.request.RequestorSelfCollectAddress.Required = true;
                }
                $scope.request.RequestorSelfCollectAddress.Confirmed = true;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorSelfCollectAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorSelfCollectAddress.Required = true;
                $scope.request.RequestorCollectAddress.Required = false;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientSelfCollectDataCtrl.$inject = ['$scope'];
        return ngClientSelfCollectDataCtrl;
    }());
    var ngClientSelfCollectData = (function () {
        function ngClientSelfCollectData() {
            this.controller = ngClientSelfCollectDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.self.collect.adress.data.html";
        }
        ngClientSelfCollectData.Factory = function () {
            var d = function () { return new ngClientSelfCollectData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientSelfCollectData;
    }());
    clientDirectives.ngClientSelfCollectData = ngClientSelfCollectData;
    /** edycja danych adresowych odbioru sprzętu*/
    var ngClientSelfCollectDataListCtrl = (function () {
        function ngClientSelfCollectDataListCtrl($scope, service) {
            this.service = service;
            //metody
            $scope.selectedAddress = {};
            service.getExternalStoreAddresses($scope.request.PartnerName)
                .then(function (d) {
                $scope.ADDRESSES = d.data;
                $scope.selectedAddress.address = $scope.mapRequestModelToFormModel($scope.request.RequestorSelfCollectAddress);
            });
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorSelfCollectAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                if ($scope.request.TypeOfItemCollect === 0) {
                    $scope.request.RequestorCollectAddress.Required = false;
                    $scope.request.RequestorSelfCollectAddress.Required = true;
                }
                $scope.request.RequestorSelfCollectAddress.Confirmed = true;
            };
            $scope.mapFormModelToRequestModel = function () {
                $scope.request.RequestorSelfCollectAddress.PostalCode = $scope.selectedAddress.address.postcode;
                $scope.request.RequestorSelfCollectAddress.District = $scope.selectedAddress.address.voivodeship;
                $scope.request.RequestorSelfCollectAddress.City = $scope.selectedAddress.address.city;
                $scope.request.RequestorSelfCollectAddress.ShopName = $scope.selectedAddress.address.name;
                $scope.request.RequestorSelfCollectAddress.Street = $scope.selectedAddress.address.street;
                $scope.request.RequestorSelfCollectAddress.Confirmed = false;
            };
            $scope.mapRequestModelToFormModel = function (requestModel) {
                var formModel = {
                    postcode: requestModel.PostalCode,
                    voivodeship: requestModel.District,
                    city: requestModel.City,
                    name: requestModel.ShopName,
                    street: requestModel.Street
                };
                return formModel;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorSelfCollectAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorSelfCollectAddress.Required = true;
                $scope.request.RequestorCollectAddress.Required = false;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientSelfCollectDataListCtrl.$inject = ['$scope', 'ngClientSelfCollectDataSrv'];
        return ngClientSelfCollectDataListCtrl;
    }());
    var ngClientSelfCollectDataList = (function () {
        function ngClientSelfCollectDataList() {
            this.controller = ngClientSelfCollectDataListCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.self.collect.adress.data.list.html";
        }
        ngClientSelfCollectDataList.Factory = function () {
            var d = function () { return new ngClientSelfCollectDataList(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientSelfCollectDataList;
    }());
    clientDirectives.ngClientSelfCollectDataList = ngClientSelfCollectDataList;
    var ngClientSelfCollectDataSrv = (function () {
        function ngClientSelfCollectDataSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.getExternalStoreAddresses = function (partnerName) {
                var url = '/offerBusinessData/GetExternalStoreAddresses?storeName=' + partnerName;
                return _this.$http.get(url);
            };
        }
        ngClientSelfCollectDataSrv.$inject = ['$http', '$q'];
        return ngClientSelfCollectDataSrv;
    }());
    clientDirectives.ngClientSelfCollectDataSrv = ngClientSelfCollectDataSrv;
    /** edycja adresów dostaw produktów (EDEN)*/
    var ngProductDeliveryAddressCtrl = (function () {
        function ngProductDeliveryAddressCtrl($scope) {
            //metody
            $scope.editData = function () {
            };
            $scope.cancel = function () {
            };
            $scope.saveData = function () {
                // dodanie informacji o zmianie adresu
                //$scope.request.ProductDeliveryAddress.Required = true;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            $scope.categoryFilter = function (item) {
                return (item.ProductTypeName == "FILTR DO WODY" || item.ProductTypeName == "EXPRESS");
            };
        }
        ngProductDeliveryAddressCtrl.$inject = ['$scope'];
        return ngProductDeliveryAddressCtrl;
    }());
    var ngProductDeliveryAddress = (function () {
        function ngProductDeliveryAddress() {
            this.controller = ngProductDeliveryAddressCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.product.delivery.address.html";
        }
        ngProductDeliveryAddress.Factory = function () {
            var d = function () { return new ngProductDeliveryAddress(); };
            d['$inject'] = [];
            return d;
        };
        return ngProductDeliveryAddress;
    }());
    clientDirectives.ngProductDeliveryAddress = ngProductDeliveryAddress;
    /** edycja adresów instalacji do umowy serwisowej (EDEN)*/
    var ngServiceDeliveryAddressCtrl = (function () {
        function ngServiceDeliveryAddressCtrl($scope) {
            //metody
            $scope.editData = function () {
            };
            $scope.cancel = function () {
            };
            $scope.saveData = function () {
                // dodanie informacji o zmianie adresu
                //$scope.request.ProductDeliveryAddress.Required = true;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            $scope.categoryFilter = function (item) {
                return (item.ProductTypeName == "SERWIS");
            };
        }
        ngServiceDeliveryAddressCtrl.$inject = ['$scope'];
        return ngServiceDeliveryAddressCtrl;
    }());
    var ngServiceDeliveryAddress = (function () {
        function ngServiceDeliveryAddress() {
            this.controller = ngServiceDeliveryAddressCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.service.delivery.address.html";
        }
        ngServiceDeliveryAddress.Factory = function () {
            var d = function () { return new ngServiceDeliveryAddress(); };
            d['$inject'] = [];
            return d;
        };
        return ngServiceDeliveryAddress;
    }());
    clientDirectives.ngServiceDeliveryAddress = ngServiceDeliveryAddress;
    /** dyrektywa edycji adresu*/
    var AddressNewFormCtrl = (function () {
        function AddressNewFormCtrl($scope) {
            // lista prefixow
            $scope.streetPrefixes = [
                'AL.',
                'BULW.',
                'DROGA',
                'INNE',
                'OGRÓD',
                'OS.',
                'PARK',
                'PL.',
                'RONDO',
                'RYNEK',
                'SKWER',
                'SZOSA',
                'UL.',
                'WYB.',
                'WYSPA'
            ];
            // to musi tak byc poniewaz watcher a autocomplete za pozno sie inicjuje
            $scope._isFormValidated = false;
            $scope.isAutoCompleteDisabled = function () {
                return $scope._isFormValidated;
            };
            $scope.$watch('isFormValidated', function () {
                if ($scope.isFormValidated !== $scope._isFormValidated) {
                    setTimeout(function () {
                        $scope._isFormValidated = $scope.isFormValidated;
                    }, 100);
                }
            });
        }
        AddressNewFormCtrl.$inject = ['$scope'];
        return AddressNewFormCtrl;
    }());
    var AddressNewFormDirective = (function () {
        function AddressNewFormDirective() {
            this.controller = AddressNewFormCtrl;
            this.templateUrl = "/WWW/partials/addressNewForm.html";
            this.restrict = "AE";
            this.scope = {
                address: "=",
                isRequired: "=",
                hideSpecificPlace: "=",
                isFormValidated: "=",
                liteForm: "="
            };
        }
        AddressNewFormDirective.Factory = function () {
            var d = function () { return new AddressNewFormDirective(); };
            d['$inject'] = [];
            return d;
        };
        return AddressNewFormDirective;
    }());
    clientDirectives.AddressNewFormDirective = AddressNewFormDirective;
    var AddressNewFormLiteDirective = (function () {
        function AddressNewFormLiteDirective() {
            this.controller = AddressNewFormCtrl;
            this.templateUrl = "/WWW/partials/addressNewFormLite.html";
            this.restrict = "AE";
            this.scope = {
                address: "=",
                isRequired: "=",
                hideSpecificPlace: "=",
                isFormValidated: "=",
                liteForm: "="
            };
        }
        AddressNewFormLiteDirective.Factory = function () {
            var d = function () { return new AddressNewFormLiteDirective(); };
            d['$inject'] = [];
            return d;
        };
        return AddressNewFormLiteDirective;
    }());
    clientDirectives.AddressNewFormLiteDirective = AddressNewFormLiteDirective;
    /*nowa stopka*/
    var FrontFooterDirective = (function () {
        function FrontFooterDirective() {
            this.restrict = "E";
            this.template = "\n<!-- nowy footer -->\n<div class=\"llWrapper\">\n\n    <iframe id=\"llFooter\" src=\"https://leaselink.pl/inc/dynamic-footer.php\" scrolling=\"no\" frameborder=\"0\" style=\"min-height:350px; width:100%;\"></iframe>\n\n</div>\n<script src=\"https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.14/iframeResizer.min.js\"></script>\n<script src=\"https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.14/iframeResizer.contentWindow.min.js\"></script>\n<script>\n    iFrameResize({\n        log: true,\n        heightCalculationMethod: 'lowestElement'\n    }, '#llFooter')\n</script>\n<!-- nowy footer -->\n        ";
        }
        ;
        FrontFooterDirective.Factory = function () {
            var dir = function () { return new FrontFooterDirective(); };
            dir['$inject'] = [];
            return dir;
        };
        return FrontFooterDirective;
    }());
    clientDirectives.FrontFooterDirective = FrontFooterDirective;
    /*  helper */
    var FrontHelpDirective = (function () {
        function FrontHelpDirective($http, $sce) {
            var _this = this;
            this.$http = $http;
            this.$sce = $sce;
            this.restrict = "E";
            this.template = "\n        <div ng-bind-html=\"renderHelpFromBackend()\"></div>\n        ";
            this.link = function (s, el, attrs) {
                s.html = '';
                var stage = top.location.href.toLocaleLowerCase();
                s.stage = stage;
                s.renderHelpFromBackend = function () {
                    return _this.$sce.trustAsHtml(s.html);
                };
                // koszyka
                if (stage.indexOf('createoffer') !== -1
                    || stage.indexOf('oferta_otwarta') !== -1
                    || stage.indexOf('oferta_dla_partnera') !== -1
                    || stage.indexOf('process/order') !== -1
                    || stage.indexOf('stacjonarny') !== -1) {
                    s.stage = 'process-order';
                }
                else if (stage.indexOf('offer/get') !== -1
                    || stage.indexOf('process/choose.offer') !== -1) {
                    s.stage = 'process-choose.offer';
                }
                else if (stage.indexOf('offerclientdata/edit') !== -1
                    || stage.indexOf('process/client.data') !== -1) {
                    s.stage = 'process-client.data.loan';
                }
                else if (stage.indexOf('payment/selectpaymentchannel') !== -1
                    || stage.indexOf('process/choose.payment.channel') !== -1) {
                    s.stage = 'process-choose.payment.channel.for';
                    // pobranie rodzaju platnosci
                    var paymentType = (s && s.paymentType) ? ('.' + s.paymentType) : '';
                    s.stage += paymentType;
                }
                else if (stage.indexOf('selfservice/index') !== -1
                    || stage.indexOf('client/service/process') !== -1) {
                    s.stage = 'process-agreement.data.loan';
                }
                // opracowanie partnera
                var partner = 'LEASELINK';
                if (s.user && s.user.Partner) {
                    partner = s.user.Partner;
                }
                else if (s.partner && s.partner.PartnerName) {
                    partner = s.partner.PartnerName;
                }
                else if (s.partner) {
                    partner = s.partner;
                }
                s.processType = 'OperationalLeasing';
                s.logged = false;
                var url = '/personalisation/help/' + partner + '?stage=' + s.stage + '&processType=' + s.processType + '&logged=' + s.logged;
                _this.$http.get(url).then(function (d) {
                    s.html = d.data;
                });
            };
        }
        ;
        FrontHelpDirective.Factory = function () {
            var dir = function ($http, $sce) { return new FrontHelpDirective($http, $sce); };
            dir['$inject'] = ['$http', '$sce'];
            return dir;
        };
        return FrontHelpDirective;
    }());
    clientDirectives.FrontHelpDirective = FrontHelpDirective;
    // pokazanie naglowka z logiem i powitaniem w zaleznosci od partnera 
    var ngShowHeader = (function () {
        function ngShowHeader() {
            this.restrict = "AE";
            this.scope = {
                partner: "="
            };
            this.templateUrl = "/WWW/partials/show.header.directive.html";
        }
        ngShowHeader.Factory = function () {
            var dir = function () { return new ngShowHeader(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngShowHeader;
    }());
    clientDirectives.ngShowHeader = ngShowHeader;
    var ngClientInfoMessageService = (function () {
        function ngClientInfoMessageService($http, $modal, $window) {
            this.$http = $http;
            this.$modal = $modal;
            this.$window = $window;
        }
        ngClientInfoMessageService.prototype.showInfoMessage = function () {
            var _this = this;
            this.$http.get("/process/helper/get-client-notification").then(function (result) {
                var showMessage = result.data.ShowMessage;
                var messageBody = result.data.MessageBody;
                var messageShown = _this.$window.sessionStorage.getItem("clientInfoMessageShown") === "true";
                if (showMessage && !messageShown) {
                    var modalInstance = _this.$modal.open({
                        animation: true,
                        templateUrl: 'clientInfoMessageTemplate',
                        controller: 'ClientInfoMessageCtrl',
                        resolve: {
                            infoMessage: function () {
                                return messageBody;
                            }
                        }
                    });
                    modalInstance.result.then(function () { return _; }, function () {
                        _this.$window.sessionStorage.setItem("clientInfoMessageShown", true);
                    });
                }
            });
        };
        ngClientInfoMessageService.$inject = ['$http', '$modal', '$window'];
        return ngClientInfoMessageService;
    }());
    clientDirectives.ngClientInfoMessageService = ngClientInfoMessageService;
    var ClientInfoMessageDirective = (function () {
        function ClientInfoMessageDirective(ngClientInfoMessageService) {
            this.ngClientInfoMessageService = ngClientInfoMessageService;
            this.restrict = "E";
            this.template = "";
            ngClientInfoMessageService.showInfoMessage();
        }
        ;
        ClientInfoMessageDirective.Factory = function () {
            var dir = function (ngClientInfoMessageService) { return new ClientInfoMessageDirective(ngClientInfoMessageService); };
            dir['$inject'] = ['ngClientInfoMessageService'];
            return dir;
        };
        return ClientInfoMessageDirective;
    }());
    clientDirectives.ClientInfoMessageDirective = ClientInfoMessageDirective;
    var ClientInfoMessageCtrl = (function () {
        function ClientInfoMessageCtrl($scope, $modalInstance, infoMessage) {
            this.$scope = $scope;
            this.$modalInstance = $modalInstance;
            this.infoMessage = infoMessage;
            $scope.infoMessage = infoMessage;
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        ClientInfoMessageCtrl.$inject = ['$scope', '$modalInstance', 'infoMessage'];
        return ClientInfoMessageCtrl;
    }());
    clientDirectives.ClientInfoMessageCtrl = ClientInfoMessageCtrl;
})(clientDirectives || (clientDirectives = {}));
